module.exports = __webpack_public_path__ + "img/circuit_favori.172b0dfd.svg";